var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "section tab-data-tracking" }, [
      _c("div", { staticStyle: { "min-width": "fit-content" } }, [
        _c("div", { staticClass: " basic-info" }, [
          _c("div", { staticClass: "basic-info-left" }, [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("p", { staticClass: "basic-info-mbl" }, [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_MblNo")))
                ]),
                _c("el-input", {
                  staticStyle: { width: "200px" },
                  attrs: { disabled: "" },
                  model: {
                    value: _vm.job.mbl,
                    callback: function($$v) {
                      _vm.$set(_vm.job, "mbl", $$v)
                    },
                    expression: "job.mbl"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "basic-info-port",
                staticStyle: { display: "table" }
              },
              [
                _c(
                  "div",
                  { staticStyle: { width: "100%", display: "flex" } },
                  [
                    _c("port-item", {
                      attrs: {
                        no: "portOfLoading",
                        icon: "/static/data_tracking/u7.png",
                        title: _vm.$t("Payment.portOfLoading"),
                        value: _vm.basicInfo.loadingPort
                      }
                    }),
                    _c("port-item", {
                      attrs: {
                        no: "portOfDestination",
                        icon: "/static/data_tracking/u8.png",
                        title: _vm.$t("Payment.portOfDestination"),
                        value: _vm.basicInfo.destinationPort
                      }
                    }),
                    _c("port-item", {
                      attrs: {
                        no: "ContainerAmount",
                        icon: "/static/data_tracking/u22.png",
                        title: _vm.$t("CargoMsg.Cargo_Flight"),
                        value: String(_vm.job.voyageFlight)
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { staticStyle: { display: "flex" }, attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("port-item", {
                          attrs: {
                            no: "portOfLoading",
                            title: _vm.$t("SeaExport.ActualQuantity"),
                            value: _vm.quantityActual
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("port-item", {
                          attrs: {
                            no: "portOfDestination",
                            title: _vm.$t("CargoMsg.Cargo_ActualWeight"),
                            value: _vm.weightActual
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _c("div", { staticStyle: { display: "flex" } }, [
          _c("div", { staticClass: "instructions" }, [
            _c("span", { staticStyle: { color: "#1F75D5" } }, [
              _vm._v(" : " + _vm._s(_vm.$t("CargoMsg.Cargo_EnterManually")))
            ]),
            _c("span", { staticStyle: { color: "#efb336" } }, [
              _vm._v(" : " + _vm._s(_vm.$t("CargoMsg.Cargo_DataService")))
            ]),
            _c("span", { staticStyle: { color: "#CCCCCC" } }, [
              _vm._v(" : " + _vm._s(_vm.$t("SeaExport.promptNoData")))
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "step-info" },
          [
            _c(
              "el-steps",
              { staticClass: "steps" },
              _vm._l(_vm.stepList, function(step) {
                return _c(
                  "el-step",
                  {
                    key: step.type,
                    staticStyle: { position: "relative" },
                    attrs: {
                      title: step.name,
                      status: step.manualIsFinish
                        ? "process"
                        : step.isFinish
                        ? "finish"
                        : "wait"
                    }
                  },
                  [
                    _c("template", { slot: "icon" }, [
                      _c("img", {
                        attrs: {
                          src:
                            "/static/data_tracking/" +
                            (step.manualIsFinish ? step.manualIcon : step.icon)
                        }
                      })
                    ]),
                    _c("template", { slot: "description" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: step.showTime,
                              expression: "step.showTime"
                            }
                          ]
                        },
                        [_vm._v(_vm._s(step.time))]
                      ),
                      _c("div", { staticStyle: { clear: "both" } })
                    ])
                  ],
                  2
                )
              }),
              1
            ),
            _c(
              "span",
              {
                staticStyle: {
                  float: "right",
                  "font-size": "20px",
                  "font-weight": "lighter"
                }
              },
              [_vm._v(_vm._s(_vm.$t("SeaExport.TopLocalTime")))]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.airFlightDetails.show,
                    expression: "airFlightDetails.show"
                  }
                ]
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "basic-info-mbl",
                    staticStyle: { "font-size": "16px", "font-weight": "bold" }
                  },
                  [_vm._v(_vm._s(_vm.$t("AirExport.FlightInformation")))]
                ),
                _c(
                  "el-table",
                  {
                    staticClass: "air-flight-details",
                    staticStyle: { width: "885px" },
                    attrs: {
                      data: _vm.airFlightDetails.rowData,
                      "span-method": _vm.mergeMethod,
                      height: "100%",
                      border: ""
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "airlineCode",
                        align: "center",
                        label: _vm.$t("SeaExport.AirlineCompany"),
                        width: "100"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "block",
                                    "text-align": "center"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.getAirlineName(scope.row)))]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        label: _vm.$t("AirExport.StartingStation"),
                        width: "100"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getStationName(scope.row.originIata)
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        label: _vm.$t("AirExport.DestinationStation"),
                        width: "100"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getStationName(
                                      scope.row.destinationIata
                                    )
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "flightNo",
                        align: "center",
                        label: _vm.$t("AirExport.FlightNumber"),
                        width: "100"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        label: _vm.$t("AirExport.DepartureTime"),
                        width: "180"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "block",
                                    "text-align": "center"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.etd
                                        ? scope.row.etd + " (ETD)"
                                        : "-"
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "block",
                                    "text-align": "center"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.atd
                                        ? scope.row.atd + " (ATD)"
                                        : "-"
                                    )
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        label: _vm.$t("AirExport.ArrivalTime"),
                        width: "180"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "block",
                                    "text-align": "center"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.eta
                                        ? scope.row.eta + " (ETA)"
                                        : "-"
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "block",
                                    "text-align": "center"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.ata
                                        ? scope.row.ata + " (ATA)"
                                        : "-"
                                    )
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "pieces",
                        label: _vm.$t("AirExport.Pieces"),
                        width: "60"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "weight",
                        label: _vm.$t("AirExport.Weight"),
                        width: "60"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c("br"),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.airTrackingDetails.show,
                    expression: "airTrackingDetails.show"
                  }
                ]
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "basic-info-mbl",
                    staticStyle: { "font-size": "16px", "font-weight": "bold" }
                  },
                  [_vm._v(_vm._s(_vm.$t("AirExport.TrackingDetails")))]
                ),
                _c(
                  "el-table",
                  {
                    staticClass: "air-flight-details",
                    staticStyle: { width: "90%" },
                    attrs: {
                      data: _vm.airTrackingDetails.rowData,
                      height: "100%",
                      "span-method": _vm.mergeMethod2,
                      border: ""
                    }
                  },
                  [
                    _c("el-table-column", {
                      staticStyle: { width: "15%" },
                      attrs: {
                        align: "center",
                        label: _vm.$t("AirExport.Airport")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.getStationName(scope.row.station))
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      staticStyle: { width: "15%" },
                      attrs: {
                        prop: "date",
                        align: "center",
                        label: _vm.$t("AirExport.Time")
                      }
                    }),
                    _c("el-table-column", {
                      staticStyle: { width: "15%" },
                      attrs: {
                        align: "center",
                        label: _vm.$t("AirExport.Status")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(_vm.getStatus(scope.row)))
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      staticStyle: { width: "15%" },
                      attrs: {
                        prop: "flightNo",
                        align: "center",
                        label: _vm.$t("AirExport.FlightNumber")
                      }
                    }),
                    _c("el-table-column", {
                      staticStyle: { width: "15%" },
                      attrs: {
                        align: "center",
                        prop: "pieces",
                        label: _vm.$t("AirExport.Pieces")
                      }
                    }),
                    _c("el-table-column", {
                      staticStyle: { width: "15%" },
                      attrs: {
                        align: "center",
                        prop: "weight",
                        label: _vm.$t("AirExport.Weight")
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "hideWire" },
        [
          _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              attrs: {
                visible: _vm.dialogVisible,
                modal: false,
                "close-on-press-escape": false,
                "close-on-click-modal": false,
                width: "350px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogVisible = $event
                }
              }
            },
            [
              _c("div", { staticClass: "text" }, [
                _c("i", { staticClass: "el-icon-warning" }),
                _c("div", { staticStyle: { "font-size": "14px" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("SeaExport.DetectionOfBasicTab"))),
                  _c("span", { staticClass: "red" }, [
                    _vm._v(
                      _vm._s(_vm.containersText.toString().replaceAll("、"))
                    )
                  ]),
                  _vm._v(
                    _vm._s(_vm.$t("SeaExport.InconsistentThePortAreaReturn"))
                  ),
                  _c("span", { staticClass: "red" }, [
                    _vm._v(
                      _vm._s(_vm.containersText.toString().replaceAll("、"))
                    )
                  ]),
                  _vm._v(
                    _vm._s(_vm.$t("SeaExport.PleaseTheOperationIsCorrect"))
                  ),
                  _c("span", { staticClass: "red" }, [
                    _vm._v(
                      _vm._s(_vm.containersText.toString().replaceAll("、"))
                    )
                  ]),
                  _vm._v(_vm._s(_vm.$t("Message.IsItCorrect"))),
                  _c("br"),
                  _vm._v(_vm._s(_vm.$t("SeaExport.YouBoxAndCargoTab"))),
                  _c(
                    "span",
                    { staticClass: "see", on: { click: _vm.toPacking } },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.GoCheck")))]
                  )
                ])
              ])
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }